import { Col, Row, Modal } from "antd";
import { useResponsive } from "../hooks/responsive";
import NavItem from "./NavItem";



const NavigationModal = ({
    isVisible, 
    onClose = e => {},
    ...props
}) => {

  const onCloseHandle = () => {
    setTimeout(onClose, 500);
  }

  return (
    <Modal
        visible={isVisible}
        wrapClassName="ant-wrapper"
        footer={null}
        closeIcon={null}
        closable={false}
        onCancel={onClose}
        width={250}
        maskStyle={{
          backgroundColor: 'rgba(0,0,0,0.7)',
        }} 
        bodyStyle={{backgroundColor: null}}
        style={{
            height: '45%',
            padding: 0,
            alignSelf: 'center',
            borderRadius: 20,
            backgroundColor: "#7b48f6"
        }}
    >
      <div className="qr-modal">
        <Row>
            <Col span={4}></Col>
            <Col span={16}>
              <div style={{paddingLeft: '10%'}}>
                <NavItem href="/home" onPress={onCloseHandle}/>
              </div>
            </Col>
            <Col span={4}></Col>
        </Row>
      </div>
      <div className="qr-modal">
        <Row>
            <Col span={4}></Col>
            <Col span={16}>
              <div style={{paddingLeft: '10%'}}>
                <NavItem href="/about" onPress={onCloseHandle}/>
              </div>
            </Col>
            <Col span={4}></Col>
        </Row>
      </div>
      <div className="qr-modal">
        <Row>
            <Col span={4}></Col>
            <Col span={16}>
              <div style={{paddingLeft: '10%'}}>
                <NavItem href="/contact" onPress={onCloseHandle}/>
              </div>
            </Col>
            <Col span={4}></Col>
        </Row>
      </div>
    </Modal>
  );
}

export default NavigationModal;
